var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 7C16.8889 7 18.8444 7.17778 21.3333 9.66667C23.8222 12.1556 24 14.1111 24 14.1111M17.0729 10.1428C17.0729 10.1428 17.9529 10.3942 19.2728 11.7141C20.5927 13.0341 20.8442 13.914 20.8442 13.914M8.00582 12.2739C7.94152 13.97 8.37078 16.8504 11.2602 19.7398C11.9573 20.4369 12.6538 20.9908 13.3333 21.4291M9.36694 9.61087C10.6051 8.37269 12.5806 8.53906 13.3668 9.94771L13.9436 10.9814C14.4643 11.9143 14.2553 13.1381 13.4353 13.958C13.4353 13.958 12.4408 14.9527 14.244 16.756C16.0467 18.5587 17.042 17.5647 17.042 17.5647C17.862 16.7447 19.0857 16.5357 20.0186 17.0564L21.0523 17.6332C22.461 18.4194 22.6273 20.3948 21.3892 21.6331C20.6452 22.3771 19.7337 22.956 18.7261 22.9941C18.0026 23.0216 17.0634 22.9592 16 22.6543",
    stroke: "#F59B48",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPhone);
export default __webpack_public_path__ + "static/media/svg_phone.8290085e2a8405664c01208b5b10cde0.svg";
export { ForwardRef as ReactComponent };